import { useSwrNoAuth } from "../swr/useSwrNoAuth";

type NextRank = {
  name: string;
  visitCountsNeededToRankUp: number;
};

export const useFetchNextRank = (restaurantId: string, lineId: string) => {
  const {
    data: nextRank,
    error,
    isLoading: isLoadingNextRank,
  } = useSwrNoAuth<NextRank>(
      `membership/restaurants/${restaurantId}/line-accounts/${lineId}/next-rank/`
  );

  // エラーの詳細メッセージ（APIが404などを返したとき）を抽出
  const errorMessage = error?.response?.data?.detail || null;

  return { nextRank, isLoadingNextRank, errorMessage };
};